"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.allGolfOrderLinesConfirmed = void 0;
const helpers_1 = require("../../helpers");
const getLatestOrderLineVersion_1 = require("./getLatestOrderLineVersion");
const allGolfOrderLinesConfirmed = (order) => {
    if (!order)
        return false;
    if (!order.order_lines)
        return false;
    if (!order.default_variant_id)
        return false;
    if (!order.variants)
        return false;
    const order_lines = order?.variants.find((variant) => variant.id === order.default_variant_id)?.order_lines;
    if (!order_lines)
        return false;
    if (order_lines.length === 0)
        return false;
    // loop through each order line and check if all versions are confirmed
    let all_confirmed = true;
    order_lines
        .filter((x) => {
        return x.type === "GOLF";
    })
        .forEach((line) => {
        if (!line.versions)
            return;
        const latest_version = (0, getLatestOrderLineVersion_1.getLatestOrderLineVersion)(line.versions);
        if (!latest_version) {
            all_confirmed = false;
            return;
        }
        // if the latest version is cancelled ignore it
        if (helpers_1.CANCELLED_ORDER_STATUSES.includes(latest_version.status))
            return;
        if (!["CONFIRMED"].includes(latest_version.status))
            all_confirmed = false;
    });
    return all_confirmed;
};
exports.allGolfOrderLinesConfirmed = allGolfOrderLinesConfirmed;
